import { useI18n } from "../lib/i18n";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="border-t border-zinc-900 mt-32"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <h2 className="font-display text-6xl md:text-8xl uppercase tracking-tighter leading-none">
            ALL<span className="text-green-400">STAR</span>
          </h2>
          <p className="mt-6 text-zinc-500 max-w-md">{t("footer_tagline")}</p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-widest text-zinc-500 mb-5">
            {t("footer_shop")}
          </h4>
          <ul className="space-y-3 text-zinc-300">
            <li>
              <a href="#shop" className="hover:text-green-400 transition-colors">
                {t("footer_all")}
              </a>
            </li>
            <li>
              <a href="#shop" className="hover:text-green-400 transition-colors">
                {t("footer_tees")}
              </a>
            </li>
            <li>
              <a href="#shop" className="hover:text-green-400 transition-colors">
                {t("footer_tracksuits")}
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-widest text-zinc-500 mb-5">
            {t("footer_follow")}
          </h4>
          <ul className="space-y-3 text-zinc-300">
            <li>
              <a href="#" className="hover:text-green-400 transition-colors">
                Instagram
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-green-400 transition-colors">
                TikTok
              </a>
            </li>
            <li>
              <a
                href="mailto:hello@allstar.brand"
                className="hover:text-green-400 transition-colors"
              >
                hello@allstar.brand
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-900">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between items-center text-xs uppercase tracking-widest text-zinc-600 gap-3">
          <span>
            {new Date().getFullYear()} {t("footer_rights")}
          </span>
          <span>{t("footer_made")}</span>
        </div>
      </div>
    </footer>
  );
}
